module.exports = { "default": require("core-js/library/fn/array/concat"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/array/concat.js
// module id = 174
// module chunks = 1